 if (Shopify.designMode) {
        document.documentElement.classList.add('shopify-design-mode');
      }
function checkVisibility() {
        var pageTop = $(document).scrollTop();
        var pageBottom = pageTop + $(window).height();
        var offset = 50;
        var tags = $("p, button, h1, h2, h3, h4, h5, h6, .button, .collection__view-all, .card__information, .footer-block__details-content, .banner__buttons, .product__info-wrapper");

        for (var i = 0; i < tags.length; i++) {
          var tag = tags[i];
          var tagOffset = $(tag).offset().top;

          if (tagOffset + offset < pageBottom && tagOffset + $(tag).height() - offset > pageTop) {
            $(tag).addClass("visible");
          } else {
            $(tag).removeClass("visible");
          }
        }
      }
$(document).on("scroll", checkVisibility);
$(document).ready(function() {
  checkVisibility();
});
$(document).ready(function () {
   $(".custom_heading_link a").first().addClass("active-new");
    $(".second-colm li").first().addClass("active-new");
    $(".custom_heading_link a").on("click", function (e) {
        e.preventDefault(); 
        $(".custom_heading_link a").removeClass("active-new");
        $(this).addClass("active-new");
        const index = $(".custom_heading_link a").index(this); 
        $(".second-colm > li").removeClass("active-new"); 
        $(".second-colm > li").eq(index).addClass("active-new");
    });
});

 $(document).ready(function () {
        // Toggle the header when mega-menu is clicked
        $(".mega-menu").click(function(event) {
          event.stopPropagation();
          $(".header").toggleClass("hd-open");
        });

        $(document).click(function(event) {
          if (!$(event.target).closest(".mega-menu").length && !$(event.target).closest(".header").length) {
            $(".header").removeClass("hd-open");
          }
        });

        $(".header").click(function(event) {
          event.stopPropagation();
        });

        // Add or remove class on .custom_heading_link a click
        $(".custom_heading_link a").click(function(event) {
          $(this).toggleClass("active");
          event.stopPropagation();  // Prevent document click from triggering if inside link
        });
      });

$(document).ready(function(){
      setInterval(function() {
        let shoulderSize = $('.cus-shoulder').val();
        let height = $('.cus-height').val();
        let hip = $('.cus-hip').val();
        let waist = $('.cus-waist').val();
        let cus_note = $('.cus-note').val();
        $('#Shoulder-Size').val(shoulderSize);
        $('#Height').val(height);
        $('#Hip').val(hip);
        $('#Waist').val(waist);
        $('#Custom-Note').val(cus_note);
      }, 1000);
      });
document.addEventListener('DOMContentLoaded', function () {
  var swiper = new Swiper('.swiper-container', {
    loop: true,
    autoplay: {
      delay: 5000000,
      disableOnInteraction: false,
    },
    slidesPerView: 1,
    spaceBetween: 0,
    grabCursor: true,
    simulateTouch: true,
    allowTouchMove: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true, 
    },
    navigation: {
      nextEl: '.swiper-button-next', 
      prevEl: '.swiper-button-prev', 
    },
    on: {
      init: function () {
        document.querySelector('.swiper-pagination').classList.remove('loading');
      },
    },
  });
});



